//Imports
import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
//Imports Context
import { AuthContext } from "../../contexts/AuthContext";
import { DepartmentContext } from "../../contexts/DepartmentContext";
//Imports Components
import home from '../../assets/icons/home.svg';
import homeHover from '../../assets/icons/homeHover.svg';
import financeLogo from '../../assets/icons/financeLogo.svg';
import financeHover from '../../assets/icons/financeHover.svg';
import projectsLogo from '../../assets/icons/projectsLogo.svg';
import projectsHover from '../../assets/icons/projectsHover.svg';
import establishmentLogo from '../../assets/icons/establishmentLogo.svg';
import establishmentHover from '../../assets/icons/establishmentHover.svg';
import holderLogo from '../../assets/icons/holderLogo.svg';
import holderHover from '../../assets/icons/holderHover.svg';
import arrowSide from '../../assets/icons/arrowSide.svg';
import arrowSideHover from '../../assets/icons/arrowSideHover.svg';
import addProjectIcon from '../../assets/icons/addProjectIcon.svg';
import userAdminIcon from '../../assets/icons/userAdminIcon.svg';
import addPMEicon from '../../assets/icons/addPMEicon.svg';
import purchasingReqIcon from '../../assets/icons/purchasingReqIcon.svg';
import contractIcon from '../../assets/icons/contractIcon.svg';
import walletIcon from '../../assets/icons/walletIcon.svg';
import followUpIcon from '../../assets/icons/followUpIcon.svg';
//Import CSS
import './navBar.css';

function NavBar({ onNavItemClick }) {
    const { userData } = useContext(AuthContext);
    const { setView, setViewObserved, setViewResponseObservation, setSelectedRequest, setCurrentRequestType, setResponseRequest } = useContext(DepartmentContext);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [expandedItem, setExpandedItem] = useState(null);

    const handleMouseEnter = (item) => {
        setHoveredItem(item);
    };

    const handleMouseLeave = () => {
        setHoveredItem(null);
    };

    const handleItemClick = (item) => {
        setExpandedItem(expandedItem === item ? null : item);
    };

    const resetDepartmentStates = () => {
        setView(false);
        setViewObserved(false);
        setViewResponseObservation(false);
        setSelectedRequest(null);
        setCurrentRequestType('purchase');
        setResponseRequest({
            responseRequest: null,
            sendTo: null,
            comments: '',
            backups: []
        })
    };


    return (
        <nav className='nav-box'>
            <h3 className='title-article'>General</h3>
            <ul>
                <li className='box-li flex' onMouseEnter={() => handleMouseEnter('home')} onMouseLeave={() => handleMouseLeave()}>
                    <NavLink
                        to='/'
                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                        onClick={onNavItemClick}
                    >
                        <img src={hoveredItem === 'home' ? homeHover : home} className='icon-nav' />
                        <p>Inicio</p>
                    </NavLink>
                </li>
                <li className='box-li flex' onMouseEnter={() => handleMouseEnter('finance') } onMouseLeave={() => handleMouseLeave()}>
                    <NavLink 
                        to='finanzas' 
                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"} 
                        onClick={onNavItemClick}
                    >
                        <img src={hoveredItem === 'finance' ? financeHover : financeLogo} className='icon-nav'/>
                        <p>Informes Finanzas</p>
                    </NavLink>
                </li>
                {/* <li className='box-li flex' onMouseEnter={() => handleMouseEnter('reports') } onMouseLeave={() => handleMouseLeave()}>
                    <NavLink 
                        to='reportes' 
                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"} 
                    >
                        <img src={hoveredItem === 'reports' ? reportsHover : reportsLogo} className='icon-nav'/>
                        <p>Reporte Cumplimiento</p>
                    </NavLink>
                </li> */}
            </ul>
            <h3 className='title-article'>Administración</h3>
            <ul className='nav-administration'>
                <li className='box-li flex' onMouseEnter={() => handleMouseEnter('projects')} onMouseLeave={() => handleMouseLeave()} onClick={() => handleItemClick('projects')} >
                    <div className='flex'>
                        <img src={hoveredItem === 'projects' ? projectsHover : projectsLogo} className='icon-nav' />
                        <p>Proyectos</p>
                    </div>
                    <img src={hoveredItem === 'projects' ? arrowSideHover : arrowSide} className='icon-nav' />
                </li>
                {expandedItem === 'projects' && (
                    <ul className='sub-menu'>
                        <li className='box-li flex'>
                            <NavLink
                                to='proyectos'
                                end
                                className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                onClick={onNavItemClick}
                            >
                                <img src={addProjectIcon} className='icon-nav' />
                                <p>Crear Proyecto</p>
                            </NavLink>
                        </li>
                        <li className='box-li flex'>
                            <NavLink
                                to='proyectos/usuarios'
                                className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                onClick={onNavItemClick}
                            >
                                <img src={userAdminIcon} className='icon-nav' />
                                <p>Administración Usuarios</p>
                            </NavLink>
                        </li>
                        {/* <li className='box-li flex'>
                            <NavLink 
                                to='proyectos/adminUsuarios' 
                                className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"} 
                            >
                                <img src={chartOfAccountIcon} className='icon-nav'/>
                                <p>Plan de Cuentas General</p>
                            </NavLink>
                        </li> */}
                    </ul>
                )}
                <li className='box-li flex' onMouseEnter={() => handleMouseEnter('establishment')} onMouseLeave={() => handleMouseLeave()} onClick={() => handleItemClick('establishment')}>
                    <div className='flex'>
                        <img src={hoveredItem === 'establishment' ? establishmentHover : establishmentLogo} className='icon-nav' />
                        <p>Establecimientos</p>
                    </div>
                    <img src={hoveredItem === 'establishment' ? arrowSideHover : arrowSide} className='icon-nav' />
                </li>
                {expandedItem === 'establishment' && (
                    <ul className='sub-menu'>
                        <li className='box-li flex'>
                            <NavLink
                                to='establecimiento/pme'
                                className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                onClick={onNavItemClick}
                            >
                                <img src={addPMEicon} className='icon-nav' />
                                <p>Ingresar PME</p>
                            </NavLink>
                        </li>
                        {userData.dimension !== 'Sostenedor' && (
                            <>
                                <li className='box-li flex'>
                                    <NavLink to='establecimiento/compras' className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"} onClick={onNavItemClick}>
                                        <img src={purchasingReqIcon} className='icon-nav' />
                                        <p>Solicitud de Compras</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='establecimiento/servicios'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                        onClick={onNavItemClick}
                                    >
                                        <img src={contractIcon} className='icon-nav' />
                                        <p>Solicitud Contrato Servicios</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='establecimiento/honorarios'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                        onClick={onNavItemClick}
                                    >
                                        <img src={contractIcon} className='icon-nav' />
                                        <p>Solicitud Contrato Honorarios</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='establecimiento/pagos'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                        onClick={onNavItemClick}
                                    >
                                        <img src={walletIcon} className='icon-nav' />
                                        <p>Solicitud de Pagos</p>
                                    </NavLink>
                                </li>
                            </>
                        )}
                        <li className='box-li flex'>
                            <NavLink
                                to='establecimiento/seguimiento'
                                className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                onClick={onNavItemClick}
                            >
                                <img src={followUpIcon} className='icon-nav' />
                                <p>Seguimiento</p>
                            </NavLink>
                        </li>
                    </ul>
                )}
                {userData?.dimension !== 'Establecimiento' && (
                    <>
                        <li className='box-li flex' onMouseEnter={() => handleMouseEnter('holder')} onMouseLeave={() => handleMouseLeave()} onClick={() => handleItemClick('holder')} >
                            <div className='flex'>
                                <img src={hoveredItem === 'holder' ? holderHover : holderLogo} className='icon-nav' />
                                <p>Sostenedor</p>
                            </div>
                            <img src={hoveredItem === 'holder' ? arrowSideHover : arrowSide} className='icon-nav' />
                        </li>
                        {expandedItem === 'holder' && (
                            <ul className='sub-menu'>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='sostenedor/sep'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                        onClick={() => {
                                            onNavItemClick && onNavItemClick();
                                            resetDepartmentStates();
                                        }}
                                    >
                                        <p>Departamento SEP</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='sostenedor/utp'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                        onClick={() => {
                                            onNavItemClick && onNavItemClick();
                                            resetDepartmentStates();
                                        }}
                                    >
                                        <p>Departamento UTP</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='sostenedor/finanzas'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                         onClick={() => {
                                            onNavItemClick && onNavItemClick();
                                            resetDepartmentStates();
                                        }}
                                    >
                                        <p>Departamento de Finanzas</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='sostenedor/adquisiciones'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                         onClick={() => {
                                            onNavItemClick && onNavItemClick();
                                            resetDepartmentStates();
                                        }}
                                    >
                                        <p>Departamento Adquisiciones</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='sostenedor/jurídico'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                         onClick={() => {
                                            onNavItemClick && onNavItemClick();
                                            resetDepartmentStates();
                                        }}
                                    >
                                        <p>Departamento Jurídico</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='sostenedor/controlInterno'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                         onClick={() => {
                                            onNavItemClick && onNavItemClick();
                                            resetDepartmentStates();
                                        }}
                                    >
                                        <p>Departamento Control interno</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='sostenedor/tesorería'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                         onClick={() => {
                                            onNavItemClick && onNavItemClick();
                                            resetDepartmentStates();
                                        }}
                                    >
                                        <p>Departamento Tesorería</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='sostenedor/remuneraciones'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                         onClick={() => {
                                            onNavItemClick && onNavItemClick();
                                            resetDepartmentStates();
                                        }}
                                    >
                                        <p>Gastos de Remuneraciones</p>
                                    </NavLink>
                                </li>
                                <li className='box-li flex'>
                                    <NavLink
                                        to='sostenedor/subsidios'
                                        className={({ isActive }) => isActive ? "style-link flex nav-link-active" : "style-link flex"}
                                         onClick={() => {
                                            onNavItemClick && onNavItemClick();
                                            resetDepartmentStates();
                                        }}
                                    >
                                        <p>Ingresos por Subvenciones</p>
                                    </NavLink>
                                </li>
                            </ul>
                        )}
                    </>
                )}
            </ul>
        </nav>
    )
}

export default NavBar;